import {
  formatCurrency,
  formatDate,
  ucfirst,
} from '@/utils';

export default (instance: any) => {
  instance.filter('currency', formatCurrency);
  instance.filter('date', formatDate);
  instance.filter('ucfirst', ucfirst);
};
